export function createLatestRequestGuard() {
  let sequence = 0;
  let activeRequest = null;

  function begin() {
    activeRequest?.controller.abort();

    const controller = new AbortController();
    const request = {
      controller,
      signal: controller.signal,
      token: ++sequence
    };

    activeRequest = request;
    return request;
  }

  function isCurrent(token) {
    return activeRequest?.token === token && !activeRequest.signal.aborted;
  }

  function finish(token) {
    if (activeRequest?.token === token) {
      activeRequest = null;
    }
  }

  function cancel() {
    activeRequest?.controller.abort();
    activeRequest = null;
  }

  return {
    begin,
    isCurrent,
    finish,
    cancel
  };
}
